import { GenericModel } from "../../../generic.model";
import { makeModel } from "../../../../service/utils/utils.service";
import { CostModel } from "./cost.model";

export class PriceModel extends GenericModel {
    public cost: CostModel;

    protected fromJson(json?: any): boolean {
        this.cost = makeModel(json.cost, CostModel);
        return this.isValid();
    }

    protected isValid(): boolean {
        return this.cost !== null;
    }
}
